import React, { Component } from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Text } from '../../extensions/LangaugeContainer';

export default class ConfirmSelectedPositionDialog extends Component {


    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{"Position Confirmation"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    <Text tid="confirmSelected"/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                    <Text tid="cancel"/>
                    </Button>
                    <Button onClick={this.props.confirmSelected} color="primary" autoFocus>
                    <Text tid="confirm"/>
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
